import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { List, User, UsersFilter } from '../models/user';
import { environment } from '../../../../environments/environment';
import { Paginator } from '../../../shared/models/paginator';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  http = inject(HttpClient);

  updateUserMe(user: User): Observable<User> {
    return this.http.patch<User>(`${environment.urlBE}users/me`, user);
  }
  userMe(): Observable<User> {
    return this.http.get<User>(`${environment.urlBE}users/me`);
  }
  insertUser(user: User) {
    return this.http.post<User>(`${environment.urlBE}users`, user);
  }

  updateUser(user: User, id: string) {
    return this.http.patch<User>(`${environment.urlBE}users/${id}`, user);
  }

  deleteUser(id: string) {
    return this.http.delete<User>(`${environment.urlBE}users/${id}`);
  }

  findUserById(id: string) {
    return this.http.get<User>(`${environment.urlBE}users/${id}`);
  }

  getAllUser(filter: UsersFilter) {
    return this.http.get<List<User>>(`${environment.urlBE}users`, {
      params: {
        ...Object.keys(filter).reduce(
          (prev, curr) => ({
            ...prev,
            ...((filter as any)[curr] !== undefined &&
            (filter as any)[curr] !== ''
              ? { [curr]: (filter as any)[curr] }
              : {}),
          }),
          {}
        ),
      },
    });
  }

   getUserOptions(): Observable<List<User>> {
      return this.http.get<List<User>>(`${environment.urlBE}users`, {
        params: {
          limit: 999,
          page: 0,
        },
      });
    }
}
